import { SearchOutlined } from "@ant-design/icons";
import { Input } from "antd";
import { debounce } from "debounce";
import { useCallback, useEffect, useRef, useState } from "react";
import { FILTER_ID } from ".";
import { removeProperty } from "../../../util/varibles/global";
import { useSiteOverview } from "../SiteOverviewContext";
import styles from '../style.module.scss';

const SearchName: React.FC = () => {
    const [search, setSearch] = useState("");
    const [call, set] = useSiteOverview(state => state.unitsFilter[FILTER_ID.SITE_NAME]);
    const timeout = useRef(debounce((value: string) => {
        if (value.length > 0) {
            set(({ unitsFilter: unitsPrev, fishgroupFilter: fishgroupPrev }) => ({
                unitsFilter: {
                    ...unitsPrev, [FILTER_ID.SITE_NAME]: ({ site, group_name = "" }) => {
                        return site.name.toLowerCase().includes(value) || group_name.toLocaleLowerCase().includes(value);
                    }
                },
                fishgroupFilter: {
                    ...fishgroupPrev, [FILTER_ID.SITE_NAME]: ({ site_name, group_name = "" }) => {
                        return site_name.toLowerCase().includes(value) || group_name.toLocaleLowerCase().includes(value);
                    }
                }
            }))
        } else {
            set(({ unitsFilter: unitsPrev, fishgroupFilter: fishgroupPrev }) => ({
                unitsFilter: removeProperty(unitsPrev, FILTER_ID.SITE_NAME),
                fishgroupFilter: removeProperty(fishgroupPrev, FILTER_ID.SITE_NAME)
            }))
        }
    }, 350));

    useEffect(() => {
        if (call === undefined) {
            setSearch("");
        }
    }, [call]);

    useEffect(() => {
        const realValue = search.trim().toLowerCase();
        timeout.current(realValue);
    }, [search]);

    const handleKeyDown = useCallback((e: any) => {
        if (e.key === 'Escape')
            setSearch('')
    }, []);

    return <Input
        value={search}
        onChange={e => setSearch(e.target.value)}
        onKeyDown={handleKeyDown}
        placeholder='Search for site or fish group ID'
        className={styles.search}
        suffix={<SearchOutlined />}
    />
}

export default SearchName;